// extracted by mini-css-extract-plugin
export default {"fieldset":"bQ_jc","captchaAndSubmitFieldset":"bQ_jd","submitButton":"bQ_jf"};